import { PromoNavigation } from '@features/club/ui/PromoNavigation/PromoNavigation';

import { useIsFeatureEnabled } from '../../../../featureToggle';

type Props = {
  activeTab: 'clubs' | 'tournaments';
};
export function PromoNavigationWidget({ activeTab }: Props) {
  const showStudio = useIsFeatureEnabled('studio');

  return <PromoNavigation activeTab={activeTab} showStudio={showStudio} />;
}
